/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: TagsContainer.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  08.07.22 10:57 am.
 * Last modified: 08.07.22 10:57 am.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';

const TagsContainer = ({ children }: ITagsContainerProps) => <div className="egt_game_tags_container">{children}</div>;

export interface ITagsContainerProps {
    children?: React.ReactNode;
}

export default TagsContainer;
